import { commonUrl } from "src/config";
import api from "./AxiosInstance";

const end = "/api";

export const CommonApi = {
  getBranches: async () => {
    const response = await api.get(end + `/getBranches`);
    return response.data;
  },
  getStaffs: async () => {
    const response = await api.get(end + `/getStaffs`);
    return response.data;
  },
  getBanks: async () => {
    const response = await api.get(end + `/getBanks`);
    return response.data;
  },
  getMasterList: async (data) => {
    const response = await api.post(end + `/getMasterList`, data);
    return response.data;
  },
  getCompanyDetails: async () => {
    const response = await api.get(`/main/getCompanyDetails`, {
      baseURL: commonUrl, // 👈 override یہاں
    });
    return response.data;
  },
};
